import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CoinsIcon, GemIcon, FileLockIcon, CarFrontIcon, UserRoundCheckIcon, ClockIcon, ArrowRightIcon, BadgeCheckIcon } from 'lucide-react';
const VAULT_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/2cf9212a-8a47-4bb5-b429-c46801cacc01.jpg';
const CONVOY_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/f8b3de46-2dc0-4ad9-b4aa-18e7bb07d6a4.jpg';
const GUARD_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/4b7f5ce9-ed19-4da6-8767-73c3900a6692.jpg';
const services = [{
  icon: CoinsIcon,
  title: 'Precious Metals',
  desc: 'Gold, silver, platinum bullion and coins protected in insured vault storage.'
}, {
  icon: GemIcon,
  title: 'Jewelry & Watches',
  desc: 'High-value jewelry, gemstones and timepieces under dual-custody protection.'
}, {
  icon: CarFrontIcon,
  title: 'Escort & Convoy',
  desc: 'Planned, discreet and professional protection for people, assets and movements.'
}, {
  icon: UserRoundCheckIcon,
  title: 'Security Guards',
  desc: 'Trained guards for residential, commercial, event and site security.'
}, {
  icon: FileLockIcon,
  title: 'Documents & Deeds',
  desc: 'Critical documents and certificates held in tamper-evident storage.'
}];
const stats = [{
  value: '$4.2B+',
  label: 'Assets under safekeeping'
}, {
  value: '24/7',
  label: 'Monitored vault security'
}, {
  value: '100%',
  label: 'Fully insured holdings'
}, {
  value: '30+',
  label: 'Years of trusted custody'
}];
export function Home() {
  return <div className="w-full bg-white" data-id="element-246" data-mp="287uijaldpp2m">
      {/* Hero */}
      <section className="relative overflow-hidden bg-steca-900" data-id="element-247" data-mp="288drw2wyr551">
        <div className="mx-auto grid max-w-6xl items-center gap-10 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:py-24" data-id="element-248" data-mp="23a2h9pyugqlr">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-249" data-mp="1z64ixhhcfjtr">
            <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-steca-200" data-id="element-250" data-mp="1kk7gkuwc7cfr">
              <ShieldCheckIcon className="h-3.5 w-3.5" data-id="element-251" data-mp="1ok7t29zvldk6" />
              Insured High-Security Custody
            </span>
            <h1 className="mt-5 font-display text-4xl font-extrabold leading-tight text-white sm:text-5xl" data-id="element-252" data-mp="1flmeepxiyioo">
              Your valuables, <span className="text-steca-300" data-id="element-253" data-mp="23aowfyw2mdjp">guarded globally.</span>
            </h1>
            <p className="mt-5 max-w-lg text-lg text-steca-100/80" data-id="element-254" data-mp="28a1qp4p9umwb">
              From Kinondoni, Dar es Salaam, Steca Global Security protects precious metals, jewelry,
              fine art and critical documents — with professional escort, convoy and guard services
              when protection needs to move with you.
            </p>
            <div className="mt-8 flex flex-wrap gap-3" data-id="element-255" data-mp="2m9axxevi26o5">
              <Link to="/verify" className="inline-flex items-center gap-2 rounded-xl bg-steca-500 px-6 py-3 font-semibold text-white transition-colors hover:bg-steca-400" data-id="element-256" data-mp="2r0j6y9sx3q0s">
                <BadgeCheckIcon className="h-5 w-5" data-id="element-257" data-mp="anis0segntzl" />
                Confirm your SKR
              </Link>
              <Link to="/services" className="inline-flex items-center gap-2 rounded-xl border border-white/20 px-6 py-3 font-semibold text-white transition-colors hover:bg-white/10" data-id="element-258" data-mp="od2r9o8u2945">
                Our services
                <ArrowRightIcon className="h-4 w-4" data-id="element-259" data-mp="3nt95zg6iwcrm" />
              </Link>
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="relative" data-id="element-260" data-mp="5o5undpyr4ir">
            <img src={VAULT_IMG} alt="Steca Global Security vault interior with gold bullion and safe deposit boxes" className="w-full rounded-2xl border border-white/10 object-cover shadow-2xl" data-id="element-261" data-mp="1h1rtxrpjemi0" />
          </motion.div>
        </div>
      </section>
      {/* Stats */}
      <section className="border-b border-steca-100 bg-steca-50" data-id="element-262" data-mp="2cdhv1v4ar7pw">
        <div className="mx-auto grid max-w-6xl grid-cols-2 gap-6 px-4 py-10 sm:px-6 md:grid-cols-4" data-id="element-263" data-mp="2hbt5o82f1m96">
          {stats.map(s => <div key={s.label} className="text-center" data-id="element-264" data-mp="2mcqlwf3v8681">
              <div className="font-display text-3xl font-extrabold text-steca-700" data-id="element-265" data-mp="2qdakln437hwa">{s.value}</div>
              <div className="mt-1 text-sm text-steca-ink/60" data-id="element-266" data-mp="2vbc05y2b0z30">{s.label}</div>
            </div>)}
        </div>
      </section>
      {/* Services */}
      <section className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20" data-id="element-267" data-mp="304nboci2a419">
        <div className="mx-auto max-w-2xl text-center" data-id="element-268" data-mp="350c4lwzksmol">
          <h2 className="font-display text-3xl font-extrabold text-steca-ink" data-id="element-269" data-mp="3a104l85s8duy">
            Protection at rest and in motion
          </h2>
          <p className="mt-3 text-steca-ink/70" data-id="element-270" data-mp="3e34wo2gl12fh">
            Secure your valuables in custody, safeguard your movements with an escort or convoy, and
            protect your property with a dependable security team.
          </p>
        </div>
        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-271" data-mp="tea7jjlr9wsr">
          {services.map((svc, i) => <motion.div key={svc.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="rounded-2xl border border-steca-100 bg-white p-6 shadow-sm transition-shadow hover:shadow-md" data-id="element-272" data-mp="ofgtnq2k43s2" data-mpi={i}>
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-steca-50 text-steca-600" data-id="element-273" data-mp="17e2ur4y2puvz">
                <svc.icon className="h-5 w-5" data-id="element-274" data-mp="24t70h4l2965e" />
              </div>
              <h3 className="mt-4 font-display text-lg font-bold text-steca-ink" data-id="element-275" data-mp="24vjre78sqqul">{svc.title}</h3>
              <p className="mt-2 text-sm text-steca-ink/70" data-id="element-276" data-mp="200nk5zuznwww">{svc.desc}</p>
            </motion.div>)}
        </div>
        <div className="mt-10 grid gap-5 lg:grid-cols-2" data-id="element-277" data-mp="26s4fbw25k23">
          <article className="overflow-hidden rounded-2xl bg-steca-900 text-white" data-id="element-278" data-mp="26a3w32d4jod">
            <img src={CONVOY_IMG} alt="Steca security convoy in Dar es Salaam" className="h-56 w-full object-cover" data-id="element-279" data-mp="3kjzquweos1x7" />
            <div className="p-6" data-id="element-280" data-mp="3pi1abig0y397">
              <h3 className="font-display text-xl font-bold" data-id="element-281" data-mp="3amlcd2cbpn7j">Secure escort &amp; convoy</h3>
              <p className="mt-2 text-sm text-steca-100/80" data-id="element-282" data-mp="3flohsnw7tvg1">Coordinated route planning and professional personnel for executive, asset and event movements across Dar es Salaam.</p>
            </div>
          </article>
          <article className="overflow-hidden rounded-2xl border border-steca-100 bg-white" data-id="element-283" data-mp="36kq9hteqv1rn">
            <img src={GUARD_IMG} alt="Professional Steca security guard on duty" className="h-56 w-full object-cover" data-id="element-284" data-mp="zutldbpkhw6x" />
            <div className="p-6" data-id="element-285" data-mp="14twqsx9gm4ff">
              <h3 className="font-display text-xl font-bold text-steca-ink" data-id="element-286" data-mp="14t4x5rzfagrs">Professional security guards</h3>
              <p className="mt-2 text-sm text-steca-ink/70" data-id="element-287" data-mp="1extqaecxt57b">Visible, attentive guard coverage for homes, businesses, worksites and special events.</p>
            </div>
          </article>
        </div>
      </section>
      {/* SKR callout */}
      <section className="bg-steca-900" data-id="element-288" data-mp="1iynaoxr681vg">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-6 px-4 py-14 sm:px-6 lg:flex-row" data-id="element-289" data-mp="1ixm00ue2hhe9">
          <div className="max-w-xl" data-id="element-290" data-mp="1xq5vr9yw0mlo">
            <div className="flex items-center gap-2 text-steca-300" data-id="element-291" data-mp="1spi0ud7jflm6">
              <ClockIcon className="h-5 w-5" data-id="element-292" data-mp="1srcmxuujpjru" />
              <span className="text-sm font-semibold uppercase tracking-wide" data-id="element-293" data-mp="26nq2gyfirb3o">Verify anytime</span>
            </div>
            <h2 className="mt-3 font-display text-3xl font-extrabold text-white" data-id="element-294" data-mp="22nnwwe6nxxj4">
              Confirm your holdings in seconds
            </h2>
            <p className="mt-3 text-steca-100/80" data-id="element-295" data-mp="89emq5un2d9y">
              Each deposit is issued a unique 8-digit SKR code. Enter it on our verification page to
              instantly view the exact items held in your name.
            </p>
          </div>
          <Link to="/verify" className="inline-flex shrink-0 items-center gap-2 rounded-xl bg-steca-500 px-7 py-4 font-semibold text-white transition-colors hover:bg-steca-400" data-id="element-296" data-mp="11rv3s6bcfcl1">
            <BadgeCheckIcon className="h-5 w-5" data-id="element-297" data-mp="1akomyetwuw46" />
            Confirm your SKR now
          </Link>
        </div>
      </section>
    </div>;
}